import { IDataEvent, DataEvent } from '../utility'

/**
 * A utility class typically used as an item in a list or combo box control that provides a unique key value and a display string.
 */
export class ListItem<T> {
    $checked: any
    constructor(
        /** The unique key value of the item. */
        public value: T,

        /** The display string of the item. */
        public display: string,

        /** An optional object to associate with the list item. */
        public tag?: any,
    ) {}

    private _selected = false
    /** Gets or sets a value indicating whether the list item is currently selected. */
    public get selected(): boolean {
        return this._selected
    }
    public set selected(value: boolean) {
        if (this._selected !== value) {
            this._selected = value
            this._selectedChanged.raise(this)
        }
    }

    private _selectedChanged = new DataEvent<ListItem<T>>()
    /** Occurs when the @see:selected value has changed. */
    public get selectedChanged(): IDataEvent<ListItem<T>> {
        return this._selectedChanged
    }
}

/** True when two combo sources have the same values and labels in the same order. */
export function listItemsUnchanged<T>(current: ListItem<T>[], next: ListItem<T>[]): boolean {
    return (
        current.length === next.length &&
        current.every((item, i) => item.value === next[i].value && item.display === next[i].display)
    )
}

/** Keep the current array when items are unchanged so bound combo boxes do not reset. */
export function replaceListItemsIfChanged<T>(current: ListItem<T>[], next: ListItem<T>[]): ListItem<T>[] {
    return listItemsUnchanged(current, next) ? current : next
}
